import { render, staticRenderFns } from "./TabAddress.vue?vue&type=template&id=d1d463b8&scoped=true"
import script from "./TabAddress.vue?vue&type=script&lang=ts"
export * from "./TabAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d463b8",
  null
  
)

export default component.exports